import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import Filter from '@/components/Filter';
import { fetchUserGroups, updateUserGroupsFilter } from '../actions/usergroups/read';

const UserGroupsFilters = ({
  category,
  className,
  fetchData,
  filterTerm,
  fluid,
  readErrors,
  updateFilterTerm,
}) => (
  <Filter
    className={clsx('aridhia-user-groups-filter', className)}
    error={firstErrorMessage(readErrors)}
    filterTerm={filterTerm}
    fluid={fluid}
    onFilter={() => fetchData(category, 1, null, false)}
    updateFilter={({ value }) => updateFilterTerm(category, value)}
  />
);

const mapStateToProps = ({
  userGroups: { userGroups },
}, { category }) => {
  const item = userGroups[category];

  return (
    {
      filterTerm: item.filter,
      readErrors: item.readErrors,
    }
  );
};

const mapDispatchToProps = {
  fetchData: fetchUserGroups,
  updateFilterTerm: updateUserGroupsFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupsFilters);
